import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import get from 'lodash-es/get';
import { ClipPathOptions } from './clip-path.interface';

@Directive({
    selector: '[finderClipPath]',
    standalone: true
})
export class ClipPathDirective implements OnInit {
    private blockData: any;
    private item: any;
    private index: number;
    private border: string;
    private type: string;

    @Input()
    set finderClipPath(options: ClipPathOptions) {
        this.blockData = options.blockData;
        this.item = options.item;
        this.index = options.index;
        this.border = options.border;
        this.type = options.type;
    }

    constructor(
        private el: ElementRef,
    ) {}

    ngOnInit() {
        // Ensure type is supported
        if (!this[this.type]) {
            throw new Error(`Unsupported clip-path type: ${this.type}`);
        }

        // Execute logic based on type provided
        this[this.type]();
    }

    imageBlock() {
        // If clip path disabled don't bother
        if (this.item.enableClipPath !== true) {
            return;
        }

        // If this is not a split class then don't bother
        if (!this.blockData.classes.includes('even-split')) {
            return;
        }

        // If the current item is a heading don't bother
        if (this.item.type === 'heading') {
            return;
        }

        let itemOffset = 0;
        if (get(this.blockData, 'items[0].type') === 'heading') {
            itemOffset = -1;
        }

        const splitType = get(this.blockData.classes.match(/(.[^\s]*)-even-split/), '[1]', '').trim();
        const splitMap = {
            two: {
                0: 'clip-left-2',
                1: 'clip-right-2',
            },
            three: {
                0: 'clip-left-3',
                1: 'clip-center-3',
                2: 'clip-right-3',
            }
        };

        const clipClass = get(splitMap, [splitType, this.index + itemOffset]);
        this.el.nativeElement.classList.add(clipClass);
    }
}
